/**
 * PagePanel — full-area form replacement (hides the list).
 * Scoped to the MasterPatternView container (position: absolute, not fixed)
 * so it does not cover the application AppShell.
 *
 * @module components/form/PagePanel
 * @see FMPV-MVWC-E003-S001 I-002
 */
import React, { type ReactNode } from 'react';

export interface PagePanelProps {
  isOpen: boolean;
  children: ReactNode;
}

export function PagePanel({ isOpen, children }: PagePanelProps) {
  if (!isOpen) return null;

  return (
    <div
      data-testid="page-panel"
      className="absolute inset-0 z-30 flex flex-col overflow-y-auto mpv-page-panel-enter"
      role="main"
    >
      {children}
    </div>
  );
}
